let PasswordStrength = /*#__PURE__*/function (PasswordStrength) {
  PasswordStrength[PasswordStrength["WEAK"] = 0] = "WEAK";
  PasswordStrength[PasswordStrength["MEDIUM"] = 1] = "MEDIUM";
  PasswordStrength[PasswordStrength["STRONG"] = 2] = "STRONG";
  PasswordStrength[PasswordStrength["VERY_STRONG"] = 3] = "VERY_STRONG";
  return PasswordStrength;
}({});

/**
 * Password Strength logic:
 * Minimum rules: at least 6 characters, 1 uppercase, 1 lowercase, at least 1 number
 * if it has less than 6 characters, should be weak
 * if it has 6 or more characters, but doesn't meet the minimum rules, should be medium
 * if it meets exactly the minimum rules, should be strong
 * if it has complexity beyond the minimum rules, should be very strong
 */
const getPasswordStrength = password => {
  const uppercaseCount = Array.from(password.match(/[A-Z]/g) || []).length;
  const lowercaseCount = Array.from(password.match(/[a-z]/g) || []).length;
  const numbersCount = Array.from(password.match(/\d/g) || []).length;
  if (password.length < 6) {
    return PasswordStrength.WEAK;
  }
  const minimumRules = uppercaseCount > 0 && lowercaseCount > 0 && numbersCount > 0;
  if (!minimumRules) {
    return PasswordStrength.MEDIUM;
  }
  if (password.length === 6 && minimumRules) {
    return PasswordStrength.STRONG;
  }
  return PasswordStrength.VERY_STRONG;
};

export { PasswordStrength, getPasswordStrength };
//# sourceMappingURL=getPasswordStrength.js.map
